import { render } from "./SupplementLog.vue?vue&type=template&id=122cfa60&scoped=true&ts=true"
import script from "./SupplementLog.vue?vue&type=script&lang=tsx"
export * from "./SupplementLog.vue?vue&type=script&lang=tsx"

import "./SupplementLog.vue?vue&type=style&index=0&id=122cfa60&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122cfa60"]])

export default __exports__